import { Box, Typography } from "@mui/material";
import { Grid, GridColumn } from "@progress/kendo-react-grid";
import React from "react";
import { magasinheader } from "../../../constante/headers/magasinHeader";
import { selectionHeaders } from "../../../constante/headers/selectionHeaders";
import { Header } from "../../../models/Header";
import { SecMagasin } from "../../../models/SecMagasin";
import { useGetSecMagasinsQuery, useGetSelectionsQuery } from "../../../redux/features/cache";
import GridWrapper from "../../grid/GridWrapper";

interface DetailProps {
  plans_seq: any;
}

function DetailComponent(props: DetailProps) {
  const { plans_seq } = props;
  const { data: selections = [] as Selection[] } = useGetSelectionsQuery({ section: plans_seq });
  const { data: secMagasins = [] as SecMagasin[] } = useGetSecMagasinsQuery({ sec: plans_seq, mag: '' });

  return (
    <Box sx={{ display: 'flex' }}>
      <Box sx={{ flexGrow: 3 }}>
        <Typography variant="h5" sx={{ pb: 1 }}>Liste des selections</Typography>
        {selections && (
          <GridWrapper>
            <Grid
              data={selections}
              rowHeight={30}
              style={{
                maxHeight: "300px",
                width: '50vw',
                overflowY: 'auto',
                overflowX: 'hidden'
              }}
            >
              {
                selectionHeaders.map((column: Header) => (
                  column.isDisplayed &&
                  <GridColumn
                    key={column.field}
                    field={column.field}
                    title={column.fieldLabel}
                    format={column.fieldFormat}
                    headerClassName={`${column.fieldFormat === '{0:c}' ? 'alignRight' : ''}`}
                    className={`${column.fieldFormat === '{0:c}' ? 'alignRight' : ''}`}
                  />
                ))}
            </Grid>
          </GridWrapper>
        )}

      </Box>
      <Box sx={{ flexGrow: 1 }}>
        <Typography variant="h5" sx={{ pb: 1 }}>Liste des magasins</Typography>
        {secMagasins && (
          <GridWrapper>
            <Grid
              data={secMagasins}
              rowHeight={30}
              style={{
                maxHeight: "300px",
                width: '30vw',
                overflowY: 'auto',
                overflowX: 'hidden'

              }}
            >
              {magasinheader.map((column: Header) => (
                column.isDisplayed &&
                <GridColumn
                  key={column.field}
                  field={column.field}
                  title={column.fieldLabel}
                  format={column.fieldFormat}
                  headerClassName={`${column.fieldFormat === '{0:c}' ? 'alignRight' : ''}`}
                  className={`${column.fieldFormat === '{0:c}' ? 'alignRight' : ''}`}
                />
              ))}
            </Grid>
          </GridWrapper>
        )}

      </Box>
    </Box>
  );
}

export default React.memo(DetailComponent);